<template>
  <IQOS :readonly="false" :title="$t('workers.workers_queue.title') + ' - Web'">
      <!-- <h4 class="version-title c-white">{{ $t('workers.workers_queue.version') }}</h4> -->
      <h4 class="c-white id-header">
          {{ $t('workers.workers_queue.id') }} 
          <span class="c-green">
              {{ cafe.qId }}
          </span>
      </h4>

      <p class="id-header mb-0 c-white">
          {{ $t('workers.workers_queue.link') }}
          <a
              class="workers-queue-link c-green"
              :href="`https://queue.qrwaiter.com.ua/login/${cafe.qId}`"
              target="_blank"
            >https://queue.qrwaiter.com.ua/login/{{cafe.qId}}</a>

      </p>

      <p class="c-grey comment mb-0">
          {{ $t('workers.workers_queue.explain') }}</p>
  </IQOS>
</template>

<script>
import IQOS from '@/components/IQOS.vue'

export default {
    components: {
        IQOS
    },
    computed: {
        cafe() {
            return this.$store.state.cafe;
        }
    }
}
</script>

<style scoped>
.id-header {
    font-size: 2vh;
}

.workers-queue-link {
    font-size: 1.8vh;
}

.workers-queue-link {

}

.version-title {
    font-size: 2.5vh;
    margin-bottom: 2vh;
}
</style>